import React, { Component } from 'react';
import { CommonValidationMessages } from '../../utils/Messages.js';
import ValidationText from '../../utils/validation/ValidationText.js';
import { isValidForm } from '../../utils/validation/CommonValidator.js';
import AccountServices from '../../services/axioServices/apiServices/AccountServices.js';
import SwalServices from '../../services/swalServices/SwalServices.js';
import CommonServices from '../../services/axioServices/apiServices/CommonServices.js';

class GstCalculation extends Component {
    constructor(props) {
        super(props);
        this.commonServices = new CommonServices();
        this.SwalServices = new SwalServices();
        this.accountServices = new AccountServices();
        this.state = {
            filterDetails: {
                month: "",
                year: "",
            },
            totalAmount: "",
            sgstAmount: "",
            cgstAmount: "",
            igstAmount: "",
            salesList: [],
            validationRules: {
                month: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "month"
                        ),
                    },
                ],
                year: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "year"
                        ),
                    },
                ],
            },
            validState: {
                isValid: true,
                error: {},
            },
        };
    }

    getTitleByRate({ cgstRate, sgstRate, igstRate }) {
        if (igstRate !== '0.00') return 'OUT SIDE STATE-SALES REGULAR';
        else if (cgstRate === '9.00' && sgstRate === '9.00') return 'LOCAL-SALES';
        else return 'LOCAL-SALES REGULAR';
    }

    getAllGSTCalculation = () => {
        let isAllFieldsValidate = this.isAllFieldsValidate();
        if (isAllFieldsValidate) {
            let request = this.state.filterDetails
            this.accountServices.getGSTCalculationList(request).then((response) => {
                if (response.statusCode === 200 && response.responseData != null) {
                    let array = response.responseData;

                    let taxSummary = { sgst: {}, cgst: {}, igst: {} };

                    let result = [];

                    array.forEach(item => {
                        if (item.subTotal === 0) return;

                        let cgstRate = ((item.cgst / item.subTotal) * 100).toFixed(0);
                        let sgstRate = ((item.sgst / item.subTotal) * 100).toFixed(0);
                        let igstRate = ((item.igst / item.subTotal) * 100).toFixed(0);

                        // Show original rates separately – don't sum them
                        let rate = `${cgstRate || 0}% CGST + ${sgstRate || 0}% SGST + ${igstRate || 0}% IGST`;

                        // Get sale type like "LOCAL-SALES REGULAR"
                        let title = this.getTitleByRate(rate);

                        result.push({
                            title: title,
                            rate: rate,
                            taxable: item.subTotal,
                            cgst: item.cgst,
                            sgst: item.sgst,
                            igst: item.igst
                        });
                    });

                    const sortOrder = [
                        'LOCAL-SALES',
                        'LOCAL-SALES REGULAR',
                        'OUT SIDE STATE-SALES REGULAR'
                    ];

                    result.sort((a, b) => {
                        return sortOrder.indexOf(a.title) - sortOrder.indexOf(b.title);
                    });

                    this.setState({ salesList: result })
                } else {
                    this.SwalServices.Error(response.Message);
                }
            });
        }
    }
    isAllFieldsValidate = () => {
        const newValidState = isValidForm(
            this.state.filterDetails,
            this.state.validationRules,
            this.state.validState
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    };
    handleChange = (event, name, section) => {
        let value = event.target.value;
        let details = this.state.filterDetails;
        details[name] = value.toUpperCase();
        this.setState({ filterDetails: details },
        );
    };
    resetForm = () => {
        let validState = this.state.validState
        validState.isValid = true
        validState.error = {}
        let Fdetails = this.state.filterDetails
        Fdetails.month = ""
        Fdetails.year = ""
        this.setState({
            filterDetails: Fdetails,
        });
    }

    render() {
        return (
            <div>
                <div className="item-search flex gap-2.5 !mb-3">
                    <div className="input-grp w-[10%]" >
                        <label>Month</label>
                        <input
                            className={`inputFocus ${this.state.validState?.error?.month ? "errorInput" : ""}`}
                            type="number"
                            id="month"
                            name="month"
                            autoComplete="off"
                            value={this.state.filterDetails.month}
                            onChange={(event) =>
                                this.handleChange(event, "month")
                            }
                        />
                        {/* <ValidationText
                            error={this.state.validState.error.month}
                        /> */}
                    </div>
                    <div className="input-grp w-[15%]" >
                        <label>Year</label>
                        <input
                            className={`inputFocus ${this.state.validState?.error?.year ? "errorInput" : ""}`}
                            type="number"
                            id="year"
                            name="year"
                            autoComplete="off"
                            value={this.state.filterDetails.year}
                            onChange={(event) =>
                                this.handleChange(event, "year")
                            }
                        />
                        {/* <ValidationText
                            error={this.state.validState.error.year}
                        /> */}
                    </div>
                    <div className="btn-grp mt-auto">
                        <button
                            className={`add-btn mt-auto`}
                            onClick={() => this.getAllGSTCalculation()}>
                            Search
                        </button>
                        <button
                            className={`cancel-btn mt-auto`}
                            onClick={() => this.resetForm()}>
                            cancel
                        </button>
                        {this.state.itemListing && this.state.itemListing.length > 0 ?
                            <button className="print-btn mt-auto" onClick={() => this.printPartyWiseDespatchData()}>Print</button>
                            : null}
                    </div>
                </div>
                <div className="table-upper">
                    <p className="mb-[3px] mt-[10px] text-[15px] font-medium text-[#474747]" >
                        Sales
                    </p>
                </div>
                <div class="item-listing">
                    <div class="itemList-table">
                        <div class="table-container h-[31vh]" >
                            <table class="itemList">
                                <thead>
                                    <tr>
                                        <td style={{ width: "25%" }}>Description</td>
                                        <td style={{ width: "10%" }}>Rate</td>
                                        <td style={{ width: "20%" }}>Taxable Amount</td>
                                        <td style={{ width: "15%" }}>SGST Amount</td>
                                        <td style={{ width: "15%" }}>CGST Amount</td>
                                        <td style={{ width: "15%" }}>IGST Amount</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.salesList && this.state.salesList.length > 0 ? (
                                        this.state.salesList.map((details, key) => (
                                            <tr key={key} className="hover:bg-gray-200 cursor-pointer ">
                                                <td>{details.title}</td>
                                                <td>{details.rate}</td>
                                                <td>{details.taxable}</td>
                                                <td>{details.sgst}</td>
                                                <td>{details.cgst}</td>
                                                <td>{details.igst}</td>
                                            </tr>
                                        ))
                                    ) : null}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div className="table-upper">
                    <p className="mb-[3px] mt-[10px] text-[15px] font-medium text-[#474747]" >
                        Purchase
                    </p>
                </div>
                <div class="item-listing">
                    <div class="itemList-table">
                        <div class="table-container h-[31vh]" >
                            <table class="itemList">
                                <thead>
                                    <tr>
                                        <td style={{ width: "25%" }}>Description</td>
                                        <td style={{ width: "10%" }}>Rate</td>
                                        <td style={{ width: "20%" }}>Taxable Amount</td>
                                        <td style={{ width: "15%" }}>SGST Amount</td>
                                        <td style={{ width: "15%" }}>CGST Amount</td>
                                        <td style={{ width: "15%" }}>IGST Amount</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.partyWiseDespatchList && this.state.partyWiseDespatchList.length > 0 ? (
                                        this.state.partyWiseDespatchList.map((details, key) => (
                                            <tr
                                                key={key}
                                                className="hover:bg-gray-200 cursor-pointer "
                                                onClick={() =>
                                                    this.getAllPartyWiseDespatchItemById(details._id)
                                                }
                                            >
                                                <td>{details.partyId.partyName}</td>
                                                <td>{details.grandTotal}</td>
                                            </tr>
                                        ))
                                    ) : null}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div className="item-sections w-[65%]  ml-auto mt-3 !p-3  !bg-white rounded-[10px]" style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px ', backgroundColor: "#f5f5f5" }}>
                    <div className='flex gap-2.5 '>
                        <div className="w-full">
                            <label>Total Taxable Amount</label>
                            <input
                                className='h-[36px]'
                                type="number"
                                id="totalAmount"
                                name="totalAmount"
                                autocomplete="off"
                                disabled
                                value={this.state.totalAmount}
                            />
                        </div>
                        <div className="min-w-[22%]">
                            <label>Total SGST Amount</label>
                            <input
                                className='h-[36px]'
                                type="number"
                                id="sgstAmount"
                                name="sgstAmount"
                                autocomplete="off"
                                disabled
                                value={this.state.sgstAmount}
                            />
                        </div>
                        <div className="min-w-[22%]">
                            <label>Total CGST Amount</label>
                            <input
                                className='h-[36px]'
                                type="text"
                                id="cgstAmount"
                                name="cgstAmount"
                                autocomplete="off"
                                disabled
                                value={this.state.cgstAmount}
                            />
                        </div>
                        <div className="min-w-[22%]">
                            <label>Total IGST Amount</label>
                            <input
                                className='h-[36px]'
                                type="text"
                                id="igstAmount"
                                name="igstAmount"
                                autocomplete="off"
                                disabled
                                value={this.state.igstAmount}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default GstCalculation;